export const SAVE_ALL_BANKS = 'SAVE_ALL_BANKS'